/**
 * Clerk publishable key (frontend). Vite puede unificar varias fuentes en build — ver vite.config.ts.
 */

export function getClerkPublishableKey(): string | undefined {
  const raw = (
    (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined) ||
    (import.meta.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY as string | undefined) ||
    ""
  ).trim();
  return raw.length > 0 ? raw : undefined;
}

/** true si parece una publishable key de Clerk (pk_test_ / pk_live_). */
export function isLikelyClerkPublishableKey(key: string): boolean {
  const k = key.trim();
  if (k.length < 16) return false;
  return k.startsWith("pk_test_") || k.startsWith("pk_live_");
}
